import { t } from '../../../locales/index';

const coreModuleRoutes = {
	path: 'core',
	component: () => import('./module-layout.vue'),
	children: [
		{
			path: 'profile',
			component: () => import('./pages/profile/index.vue'),
			meta: {
				title: t('core.my-profile'),
			},
		},
		{
			path: 'change-plan',
			component: () => import('./pages/change-plan.vue'),
			meta: {
				title: t('core.change-plan'),
			},
		},
		{
			path: 'reactivate-plan',
			component: () => import('./pages/reactivate-plan.vue'),
			meta: {
				title: t('core.reactivate-plan'),
			},
		},
		{
			path: 'onboarding',
			name: 'onboarding',
			component: () => import('./pages/onboarding/index.vue'),
			meta: {
				title: t('core.onboarding.page_title'),
			},
		},
	],
};

export { coreModuleRoutes };
